export const GET_SHIP_SERVICES = "GET_SHIP_SERVICES";
export const GET_SHIP_SERVICE_BY_ID = "GET_SHIP_SERVICE_BY_ID";
export const UPDATE_SHIP_SERVICE = "UPDATE_SHIP_SERVICE";
export const DELETE_SHIP_SERVICE = "DELETE_SHIP_SERVICE";
export const CREATE_SHIP_SERVICE = "CREATE_SHIP_SERVICE";
